var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.86765H11.4167M4.08333 0.75H8.08333M4.75 9.92647V5.69118M7.41667 9.92647V5.69118M8.41667 12.75H3.75C3.01362 12.75 2.41667 12.1179 2.41667 11.3382L2.11227 3.60292C2.09649 3.20189 2.39928 2.86765 2.77836 2.86765H9.38831C9.76739 2.86765 10.0702 3.20189 10.0544 3.60292L9.75 11.3382C9.75 12.1179 9.15305 12.75 8.41667 12.75Z",
    stroke: "#EE3B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNew);
export default __webpack_public_path__ + "static/media/delete_new.96369ec0337231254cba43d9f1088b4e.svg";
export { ForwardRef as ReactComponent };